export const DEFAULT_USER_FACING_ERROR_MESSAGE = "Something went wrong. Please try again or contact support."
const CLIENT_FRIENDLY_ERROR_STATUS = 599

const USER_FACING_ERROR_CODE_ALLOWLIST = new Set([
	"auth/invalid-email",
	"auth/missing-email",
	"auth/missing-password",
	"auth/email-already-in-use",
	"auth/weak-password",
	"auth/popup-closed-by-user",
	"auth/popup-blocked",
	"auth/expired-action-code",
	"auth/invalid-action-code",
])

const USER_FACING_ERROR_MESSAGE_BY_CODE = Object.freeze({
	"permission-denied": "You don't have permissions to perform this action.",
	"auth/user-not-found": "Incorrect email or password",
	"auth/wrong-password": "Incorrect email or password",
	"auth/invalid-credential": "Incorrect email or password",
})

export function getUserFacingErrorMessage(error) {
	let code = error?.code

	if(error?.response?.status === CLIENT_FRIENDLY_ERROR_STATUS && error.response.data?.error){
		return error.response.data.error
	}
	if(code && USER_FACING_ERROR_CODE_ALLOWLIST.has(code) && error.message){
		return error.message
	}
	if(code && USER_FACING_ERROR_MESSAGE_BY_CODE[code]){
		return USER_FACING_ERROR_MESSAGE_BY_CODE[code]
	}
	return DEFAULT_USER_FACING_ERROR_MESSAGE
}
